import Carousel from 'react-bootstrap/Carousel';
import { logistica_GUIA_FOTO } from '@pcgerente-node/pcg-comun/dist/DTOs';

interface ChildsProps {
    fotos: logistica_GUIA_FOTO[]
}


const CarruselImagenesDetalles: React.FC<ChildsProps>= ({fotos}) => {
  return (
    <Carousel 
        slide={false}
        indicators={false}
        keyboard={true}
        prevLabel={""} 
        nextLabel={""}
        touch={true}
     >
        {fotos.map((foto, i) => 
            <Carousel.Item>
        <img
          className="d-block w-100"
          src={foto.url}
          alt={`foto #${i}`}
          />
      </Carousel.Item>
    )}
    </Carousel>
  );
}

export default CarruselImagenesDetalles